function findParent(obj, parentType) {
    if (obj.parent) {
        if (obj.parent.type === parentType) {
            return obj.parent;
        }
        return findParent(obj.parent, parentType);
    }
}

export { findParent };
//# sourceMappingURL=find-parent.js.map
